import type React from "react"

import { TableCell, TableRow } from "@/components/ui/table"

import LiveDigesterMetricDisplay from "./LiveDigesterMetricDisplay"

import type { DigesterConfig, MetricColorRange } from "../types/feedstockTypes"

export default function Digester7DayRow({
  digesters,
  values,
  isPending,
  label,
  colorRange,
}: {
  digesters: DigesterConfig[]
  values?: Record<number, number>
  isPending: boolean
  label: React.ReactNode
  colorRange: MetricColorRange[]
}) {
  const avg = values
    ? Object.entries(values).reduce((a, c) => a + c[1] / Object.entries(values).length, 0)
    : undefined
  return (
    <TableRow>
      <TableCell className="p-4">
        <span className="font-semibold text-muted-foreground">{label}</span>
      </TableCell>
      {digesters.map((d) => (
        <TableCell key={d.key} className="w-[80px] p-4">
          <LiveDigesterMetricDisplay
            value={values ? values[d.key] : undefined}
            isLoading={isPending}
            colorRanges={colorRange}
            type={"Rate"}
          />
        </TableCell>
      ))}
      <TableCell className="w-[80px] p-4 font-semibold">
        <LiveDigesterMetricDisplay value={avg} isLoading={!avg} colorRanges={[]} type={"Rate"} />
      </TableCell>
    </TableRow>
  )
}
